import React from 'react'

export const ENTER = 'Enter'

const FormTextarea = ({
  name,
  placeholder,
  disabled,
  value,
  onBlur,
  onChange,
  preventKeys = [],
}) => {
  return (
    <textarea
      name={name}
      value={value}
      onBlur={onBlur}
      onChange={(e) => {
        if (preventKeys?.includes(ENTER)) {
          e.target.value = e.target.value.replace(/\n/g, ' ')
        }
        onChange(e)
      }}
      onKeyPress={(e) => {
        if (preventKeys?.includes(e.key)) {
          e.preventDefault()
        }
      }}
      className="formtextarea formfield__input"
      disabled={disabled}
      placeholder={placeholder ? placeholder : ''}
    ></textarea>
  )
}

export default FormTextarea
